import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { selectRefreshToken, reauthorize } from "../../slices/staffSlice";
import { adminPortalRequest } from "../../Requests/getRequests";
import { Button } from "../../components";
import { hide } from "../../slices/toastSlice";
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkCircle01Icon, AlertCircleIcon, Cancel01Icon } from '@hugeicons/core-free-icons';

function Toast() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const refreshToken = useSelector(selectRefreshToken);
    const [processing, setProcessing] = useState(false);

    const state = useSelector((state) => state.toast.state);
    const message = useSelector((state) => state.toast.message);
    const type = useSelector((state) => state.toast.type);

    const isSessionExpired = message === "Your session has expired";

    const refreshRequest = async() => {
        setProcessing(true);
        let res = await adminPortalRequest(`/auth/staff/refresh_token`, "GET", {
            "Content-Type": "application/json",
            "refreshtoken": `${refreshToken}`
        }, {}, {});

        if (res?.status === 501) { navigate("/login"); return; }

        if (res?.accessToken) {
            dispatch(reauthorize(res));
            setProcessing(false);
            setTimeout(() => dispatch(hide()), 500);
        } else {
            navigate("/login");
        }
    }

    useEffect(() => {
        if (state && !isSessionExpired) {
            const id = setInterval(() => dispatch(hide()), 3000);
            return () => clearInterval(id);
        }
    }, [state, isSessionExpired, dispatch]);

    const isSuccess = type === "success";
    const isError = type === "error";

    const colors = isSuccess
        ? { bg: "bg-emerald-500", ring: "ring-emerald-400/30", shadow: "shadow-emerald-500/20" }
        : isError
        ? { bg: "bg-red-500", ring: "ring-red-400/30", shadow: "shadow-red-500/20" }
        : { bg: "bg-gray-700", ring: "ring-gray-500/30", shadow: "shadow-gray-700/20" };

    return (
        <div className={`fixed z-50 top-5 right-0 transition-all duration-300 ease-out
            ${state ? 'translate-x-0 opacity-100 mr-5' : 'translate-x-full opacity-0 mr-0'}`}
        >
            <div className={`
                flex ${isSessionExpired ? 'flex-col' : 'flex-row'} items-center gap-3
                ${colors.bg} text-white
                px-4 py-3 rounded-2xl
                shadow-xl ${colors.shadow}
                ring-1 ring-white/15
                min-w-[220px] max-w-xs
            `}>
                <div className="flex items-center gap-3 w-full">
                    <div className="shrink-0 w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                        <HugeiconsIcon
                            icon={isSuccess ? CheckmarkCircle01Icon : AlertCircleIcon}
                            size={16}
                            className="text-white"
                        />
                    </div>

                    <p className="text-sm font-medium leading-snug flex-1">{message}</p>

                    {!isSessionExpired && (
                        <button
                            onClick={() => dispatch(hide())}
                            className="shrink-0 w-6 h-6 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center transition-colors"
                            aria-label="Dismiss"
                        >
                            <HugeiconsIcon icon={Cancel01Icon} size={11} className="text-white" />
                        </button>
                    )}
                </div>

                {isSessionExpired && (
                    <div className="w-full mt-1">
                        <Button
                            btnClasses="alert-button mb-1"
                            btnText="Refresh"
                            btnFunction={refreshRequest}
                            processing={processing}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Toast;
